import * as React from 'react';
import { Row, Col, Label } from 'reactstrap';
import './notFoundData.css';

export interface INotFoundDataProps {
  label: string;
};

export default class NotFoundData extends React.Component<INotFoundDataProps, any> {
  public render() {
    return (
      <Row>
        <Col md={12}>
          <div className="not-found-data-card white-background">
            <p><Label>{this.props.label}</Label></p>
          </div>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/components/share/NotFoundData/NotFoundData.tsx